module.exports = "/_next/static/images/58f838c53fff7dd77da1da3310bc4124-roxinho-single-md@3x.jpg.webp";